// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-icon[data-v-a9a74c9e]{width:.24rem;height:.24rem;margin-left:.18rem;cursor:pointer}.account-aliases[data-v-a9a74c9e]{margin-bottom:.3rem}.account-aliases span[data-v-a9a74c9e]{margin-right:.08rem}", ""]);
// Exports
module.exports = exports;
